export default defineNuxtPlugin({
  name: 'openfeature',
  dependsOn: ['user-segment'],
  setup: async (nuxtApp) => {
    const { loaded, client } = await useOpenFeature()
    nuxtApp.provide('openfeatureLoaded', loaded)
    nuxtApp.provide('openfeature', client)

    // Each config store resolves its variant flag and then fetches one JSON.
    // app.vue awaits them before it renders anything, so if they were first
    // created there (after every plugin, including the Assertive Yield script
    // load) their round trip would sit on the serial path to the first
    // render. Creating them here, with the flag client just resolved and its
    // context final, starts the fetches while the remaining plugins run.
    // Pinia stores are singletons, so app.vue and Home.vue get the same
    // instances and the same variants they would have resolved themselves.
    // The layout skeleton is only used by the home layout, hence the route
    // check.
    useLayoutSettingsStore()
    useSiteSettingsStore()
    useAdSettingsStore()
    if (useRoute().path === '/') {
      useLayoutSkeletonStore()
    }
  },
})
